const Error = () => {
  return (
    <div className="flex justify-center items-center h-screen text-3xl text-white">
      Error - 404 Not found
    </div>
  );
};

export default Error;
